var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.593 8.02a8.057 8.057 0 0 1 7.354 7.56A11.978 11.978 0 0 0 13.783 4.693a11.976 11.976 0 0 0-5.83 4.656A8.048 8.048 0 0 1 15.519 2a12.052 12.052 0 0 0-11.044 8.744 12.033 12.033 0 0 0 4.81 13.236A8.057 8.057 0 0 1 2 16.42a11.966 11.966 0 0 0 8.63 11.2 11.985 11.985 0 0 0 13.294-4.83A7.98 7.98 0 0 1 16.429 30a11.982 11.982 0 0 0 11.138-8.733A11.963 11.963 0 0 0 22.593 8.02zm-6.654 13.02a4.836 4.836 0 0 1-3.503-1.47 4.97 4.97 0 0 1 2.11-8.263 4.976 4.976 0 0 1 5.818 2.443 4.967 4.967 0 0 1-1.264 6.18 4.975 4.975 0 0 1-3.161 1.11z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorn);
export default __webpack_public_path__ + "static/media/TORN.3b5c8af5832eb9ed25828ad35f2575e1.svg";
export { ForwardRef as ReactComponent };